"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.713 12c0 .34-.031.66-.072.98l2.169 1.65c.195.15.247.42.123.64l-2.056 3.46a.508.508 0 01-.627.22l-2.56-1a7.94 7.94 0 01-1.737.98l-.39 2.65a.497.497 0 01-.505.42H9.946a.497.497 0 01-.504-.42l-.39-2.65a7.564 7.564 0 01-1.738-.98l-2.56 1a.524.524 0 01-.627-.22l-2.056-3.46a.495.495 0 01.124-.64l2.169-1.65a7.716 7.716 0 01-.072-.98c0-.33.03-.66.072-.98l-2.17-1.65a.484.484 0 01-.123-.64l2.056-3.46c.124-.22.391-.31.628-.22l2.56 1a7.94 7.94 0 011.737-.98l.39-2.65A.498.498 0 019.946 2h4.112c.257 0 .473.18.504.42l.39 2.65c.628.25 1.204.58 1.738.98l2.56-1c.226-.08.504 0 .627.22l2.056 3.46c.124.22.072.49-.123.64l-2.17 1.65c.042.32.073.64.073.98zM8.5 12c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5z" }), "Settings");
//# sourceMappingURL=Settings.js.map